import { render } from "./SessionWarningModal.vue?vue&type=template&id=4621b252&scoped=true"
import script from "./SessionWarningModal.vue?vue&type=script&lang=js"
export * from "./SessionWarningModal.vue?vue&type=script&lang=js"

import "./SessionWarningModal.vue?vue&type=style&index=0&id=4621b252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4621b252"]])

export default __exports__